import cx from 'clsx';
import { Input as AriaInput, type InputProps } from 'react-aria-components';
import { forwardRef } from 'react';
import styles from './input.module.css';

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...props },
  ref
) {
  return <AriaInput className={cx(styles['input-field'], className)} ref={ref} {...props} />;
});
